var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topBanner"},[_c('img',{staticClass:"game_logo",attrs:{"src":_vm.detail.game_logo_url,"alt":""}}),_c('div',{staticClass:"game_name"},[_vm._v(_vm._s(_vm.detail.game_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }